<script>
import formatDate from '@utils/format-date'
import formatCurrency from "@utils/format-currency";
import  { formatOrder } from "@utils/format-order";
import { merchantComputed } from "@store/helpers";
import { orderIsCanPay, orderIsOffline, orderParamsList } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
import { conditionList } from "@utils/is-condition";

export default {
  props: {
    orderItem: {
      type: Object,
      // required: true,
      default: () => {}
    },
  },
  data() {
    const {
      payment,
      billingAddress, 
      shippingAddress,
      shippingMethod,
      items,
      coupons_total_discount,
      coupons,
      total
    } = this.orderItem
    const mappingPaymentMethod = {
      'Credit card': '信用卡',
      'ATM': 'ATM',
      'Pos cash': '現金',
      'Pos credit': '現場刷卡'
    }
    const paymentMethod = mappingPaymentMethod[payment.method]
    const productTotal = items.reduce((prev, cur) => prev += cur.subtotal, 0)
    const couponCodes = coupons.map(({code}) => code).join('・')

    return {
      paymentParams: conditionList([
        {
          title: '付款方式：',
          text: paymentMethod === 'Credit card' ? '信用卡' : 'ATM',
        },
        {
          title: '付款日期：',
          text: formatDate(payment.payDate, 'yyyy/MM/dd HH:mm:ss'),
          condition: () => paymentMethod === 'Credit card'
        },
        {
          title: '轉帳銀行：',
          text: payment.bankCode,
          condition: () => paymentMethod === 'ATM'
        },
        {
          title: '轉帳帳號：',
          text: payment.account,
          condition: () => paymentMethod === 'ATM'
        },
        {
          title: '轉帳期限：',
          // text: formatDate(payment.expireDate, 'yyyy/MM/dd HH:mm:ss'),
          text: payment.expireDate,
          condition: () => paymentMethod === 'ATM'
        },
      ]),
      otherParams: conditionList([
        {
          title: '運送方式：',
          text: shippingMethod === 'shipping' ? '宅配' : '超商取貨',
        },
        {
          title: '商品金額：',
          text: `NT $${formatCurrency(productTotal)}`,
        },
        {
          title: '優惠券折抵：',
          text: `NT $${formatCurrency(coupons_total_discount)}（${couponCodes}）`,
          condition: () => coupons.length > 0
        },
        {
          title: '點數折抵：',
          text: '',
          condition: () => false
        },
        {
          title: '稅金：',
          text: '',
          condition: () => false
        },
        {
          title: '訂單總計：',
          text: `NT $${formatCurrency(total)}`,
        },
      ]),
      billingParams: conditionList([
        {
          title: billingAddress.name,
          text: '',
        },
        {
          title: billingAddress.phone,
          text: '',
        },
        {
          title: billingAddress.postcode,
          text: '',
        },
        {
          title: `${billingAddress.city}${billingAddress.address}`,
          text: '',
        },
      ]),
      shippingParams: conditionList([
        {
          title: shippingMethod === 'shipping' ? shippingAddress.name : shippingAddress.consignee,
          text: '',
        },
        {
          title: shippingMethod === 'shipping' ? shippingAddress.phone : shippingAddress.consigneePhone,
          text: '',
        },
        {
          title: shippingAddress.postcode,
          text: '',
          condition: () => shippingMethod === 'shipping'
        },
        {
          title: shippingAddress.storeName,
          text: '',
          condition: () => shippingMethod === 'newebpay_cvscom'
        },
        {
          title: shippingMethod === 'shipping' ? `${shippingAddress.city}${shippingAddress.address}` : shippingAddress.storeAddress,
          text: '',
        },
      ]),
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    formatOrder,
    orderIsCanPay,
    formatPrice,
    formatDate,
    formatCurrency,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.reservationItemDetail">
    <el-table
      :data="orderItem.items"
      class="mb-5 d-none d-md-block"
      :class="$style.reservationList"
    >
      <el-table-column v-slot="{ row }" label="商品">
        <div class="d-flex align-items-center">
          <div class="reservationItemDetail__imageBox">
            <div class="reservationItemDetail__image">
              <div
                class="reservationItemDetail__imageInner"
                :style="{ backgroundImage: `url('${ row.image || require('@assets/images/default/plan-default-Image@2x.png') }')` }"
              >
              </div>
            </div>
          </div>
          <div class="ml-3 d-none d-md-block">{{ row.name }}</div>  
        </div>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="數量" width="100">
        <span class="font-number">{{ row.qty }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="單價" width="135">
        <span class="font-number">NT$ {{ formatCurrency(row.price) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="價格" width="135">
        <span class="font-number">NT$ {{ formatCurrency(row.subtotal) }}</span>
      </el-table-column>
    </el-table>
    <div class="reservationItemDetail__productBox d-md-none my-5">
      <div v-for="(item, index) in orderItem.items" :key="index" class="reservationItemDetail__productItem">
        <div class="reservationItemDetail__imageBox mr-3">
          <div class="reservationItemDetail__image">
            <div
              class="reservationItemDetail__imageInner"
              :style="{ backgroundImage: `url('${ item.image || require('@assets/images/default/plan-default-Image@2x.png') }')` }"
            >
            </div>
          </div>
        </div>
        <div class="flex-grow-1 font-number">
          <div class="row">
            <div class="col-12 reservationItemDetail__productName">{{ item.name }}</div>
            <div class="col-6">數量：{{ item.qty }}</div>
            <div class="col-6">價格：NT$ {{ formatCurrency(item.subtotal) }}</div>
            <div class="col-12">單價：NT$ {{ formatCurrency(item.price) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="reservationItemDetail__info row mx-0">
      <div class="col-12 col-md-6 p-0 p-md-4">
        <div v-for="(item, index) in paymentParams" :key="index">{{ `${item.title}${item.text}` }}</div>
      </div>
      <div class="col-12 col-md-6 p-0 p-md-4">
        <div v-for="(item, index) in otherParams" :key="index">{{ `${item.title}${item.text}` }}</div>
      </div>
      <div class="reservationItemDetail__infoBilling col-12 col-md-6 p-4 mt-4">
        <div>會員地址</div>
        <div v-for="(item, index) in billingParams" :key="index">{{ `${item.title}${item.text}` }}</div>
      </div>
      <div class="reservationItemDetail__infoShipping col-12 col-md-6 p-4 mt-md-4">
        <div>運送地址</div>
        <div v-for="(item, index) in shippingParams" :key="index">{{ `${item.title}${item.text}` }}</div>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.reservationItemDetail {
  :global {
    .reservationItemDetail {
      &__imageBox {
        flex-shrink: 0;
        width: 80px;

        @include max-md {
          width: 70px;
          margin-bottom: 1rem;
        }
      }

      &__image {
        position: relative;
        display: block;
        padding-top: 100%;
        overflow: hidden;
      }

      &__imageInner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);

        &:hover {
          // transform: scale(1.15);
        }
      }

      &__productItem {
        display: flex;
        line-height: 1.875rem;
        padding: 1.5625rem 0;
        font-size: 12px;

        & + .reservationItemDetail__productItem {
          border-top: 1px dashed $color-line;
        }
      }

      &__productName {
        color: $color-wp-text-dark;
        font-size: 14px;
      }

      &__info {
        line-height: 2rem;
        font-size: .875rem;
        font-family: $font-number;
      }

      &__infoBilling {
        background-color: rgba($color-wp-secondary, 0.1);
        > div:first-child {
          font-size: 1rem;
          color: $color-wp-secondary-dark;
        }
      }

      &__infoShipping {
        background-color: rgba($color-wp-primary, 0.1);
        > div:first-child {
          font-size: 1rem;
          color: $color-wp-primary-dark;
        }
      }
    }
  }
}

.reservationList {
  :global {
    .reservationList {
      &__title {
        font-weight: 500;
      }

      &__date, &__meta {
        font-size: 0.75rem;
        color: $color-gray-2;
        letter-spacing: 0.1em;
      }

      &__productName {
        .cell {
          visibility: hidden;
          opacity: 0;
        }
        
      }
    }

    // stylelint-disable selector-class-pattern
    @include max-md {
      .el-table__header-wrapper {
        display: none;
      }

      .el-table__row {

      }
    }
    

    // stylelint-enable selector-class-pattern
  }
}
</style>
